// extracted by mini-css-extract-plugin
export default {"shalinaInpute":"input_shalinaInpute__p7ehA","shalinaMobileinputWrapper":"input_shalinaMobileinputWrapper__4iApK","shalinaMobileinput":"input_shalinaMobileinput__pWtRA"};